import { render, staticRenderFns } from "./imBusinessStatus.vue?vue&type=template&id=9f0cb652&scoped=true"
import script from "./imBusinessStatus.vue?vue&type=script&lang=js"
export * from "./imBusinessStatus.vue?vue&type=script&lang=js"
import style0 from "./imBusinessStatus.vue?vue&type=style&index=0&id=9f0cb652&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0cb652",
  null
  
)

export default component.exports